import JobPosition from '@/models/JobPosition/JobPosition';

export default class JobPositionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.userInfoId  = '';
		this.userInfoFirstName = '';
		this.approvalStructureId  = '';
		this.approvalStructureName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			userInfoId : '0',
			userInfoFirstName : '0',
			approvalStructureId : '0',
			approvalStructureName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}